const data = {
	"bgyx":{
		"ch":"中文",
		"en":"English"
	}
}
export default {
	data
}